/* eslint-disable react/no-danger */
import { memo } from 'react';
import { GetServerSideProps } from 'next';
import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';
import { GET_DETAIL_NEWS } from '@containers/DetailNews/slice';
import DetailNews from '@containers/DetailNews';

function detailNewsContainer() {
  return <DetailNews />;
}

export const getServerSideProps: GetServerSideProps =
  wrapper.getServerSideProps(store => async ({ params }) => {
    const { id, slug } = params || {};

    store.dispatch(GET_DETAIL_NEWS({ id, slug }));
    store.dispatch(END);
    await (store as SagaStore).sagaTask?.toPromise();

    return {
      props: {},
    };
  });

export default memo(detailNewsContainer);
